import React, { Fragment } from 'react';
import CarouselSection from './components/CarouselSection';
import SearchPropertiesSection from './components/SearchPropertiesSection';
import HighlightedProjects from './components/HighlightedProjects';
import ServicesContactSection from './components/ServicesContactSection';
import InformationSection from './components/Information';
import BenefitComponent from './components/BenefitUnne';
import HeroAsociate from '../../Carousel/HeroAsociate';
import ImageHero from '../../../assets/img/asociate/QUIERES SER UN CORREDOR EXITOSO.webp'


const HomeComponent = () => {
  return (
    <Fragment>
      {/* <CarouselSection /> */}
      <HeroAsociate data={[
        {
          id: 1,
          title:'¿Quieres ser un corredor exitoso?',
          titleTwo:'',
          desc: 'Únete a la red mas importante de corredores y multiplica tus oportunidades',
          img: ImageHero,
        },
      ]} /> 
      {/* <SearchPropertiesSection /> */}
      {/* <HighlightedProjects /> */}
      <BenefitComponent />
      {/* <InformationSection/> */}
      <ServicesContactSection />
    </Fragment>
  );
};

export default HomeComponent;
